import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'cp-training-cancelled-notification',
  templateUrl: './training-cancelled-notification.component.html',
  styleUrls: ['./training-cancelled-notification.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class TrainingCancelledNotificationComponent {
  constructor(private _router: Router) {}

  public get isNotTrainingPage(): boolean {
    return !this._router.url.startsWith('/training');
  }
}
